import { Badge, Tag } from 'antd';
import { ColumnsType } from 'antd/es/table';
import { ArrowRightShort } from 'react-bootstrap-icons';

import { getDomainVisitorLabel } from '@/modules/Domains';
import { RedirectsListTableDataObj, getRedirectMatchModeLabel } from '@/modules/Sites';

export const columns: ColumnsType<RedirectsListTableDataObj> = [
  {
    title: 'Стан',
    dataIndex: 'isActive',
    key: 'isActive',
    width: 24,
    render: (isActive: RedirectsListTableDataObj['isActive']) => <Badge status={ isActive ? 'success' : 'default' }/>,
  },
  {
    title: 'Джерело',
    dataIndex: 'sourceLabel',
    key: 'sourceLabel',
    render: (sourceLabel: RedirectsListTableDataObj['sourceLabel']) => sourceLabel,
  },
  {
    key: 'arrow',
    width: 24,
    render: () => <ArrowRightShort size={ 18 }/>,
  },
  {
    title: 'Ціль',
    dataIndex: 'targetLabel',
    key: 'targetLabel',
    render: (targetLabel: RedirectsListTableDataObj['targetLabel']) => targetLabel,
  },
  {
    title: 'Режим',
    dataIndex: 'matchMode',
    key: 'matchMode',
    width: 130,
    render: (matchMode: RedirectsListTableDataObj['matchMode']) => <Tag color="purple">{ getRedirectMatchModeLabel(matchMode) }</Tag>,
  },
  {
    title: 'Код',
    dataIndex: 'statusCode',
    key: 'statusCode',
    width: 70,
    render: (statusCode: RedirectsListTableDataObj['statusCode']) => <Tag color="blue">{ statusCode }</Tag>,
  },
  {
    title: 'Для відвідувача',
    dataIndex: 'forVisitor',
    key: 'forVisitor',
    width: 110,
    render: (forVisitor: RedirectsListTableDataObj['forVisitor']) => <Tag color="geekblue">{ getDomainVisitorLabel(forVisitor) }</Tag>,
  },
];